(function ($) {
    function init__onboard() {
        const 
            className = 'onboard',
            prefix = '.' + className,
            container = $(prefix);

        container.each(function(){
            let $this = $(this),
                card = $this.find('.card'),
                tl = gsap.timeline({});

            gsap.set(card, {y: 100, opacity: 0});

            tl
                .to($this, 0, {opacity: 1,})
                .to(card, 1, {x: 0, y: 0, opacity: 1, stagger: 0.4, ease: "Power3.easeOut"} )

            return tl;
        });
    }

    $(window).on('load', function() {
        init__onboard();
    });
    
    // run function after barba enter
    if(window.barba !== undefined) {
        barba.hooks.enter((data) => {
            init__onboard();
        });
    }
    
})(jQuery);